<template lang="pug">
v-card.rounded-lg(color="white" flat)
  .pa-6
    template(v-if="loading")
      v-skeleton-loader(type="list-item-three-line")
    template(v-else)
      .text-xl.font-semibold.mb-4 {{ title }}
      v-row
        v-col(cols="12" md="6")
          .text-sm.font-medium.neutral500--text.mb-1 {{ titleFirst }}
          .text-g5 {{ valueFirst }}
        v-col(cols="12" md="6")
          .text-sm.font-medium.neutral500--text.mb-1 {{ titleSecond }}
          .text-g5 {{ valueSecond }}
        v-col(cols="12" md="6")
          .text-sm.font-medium.neutral500--text.mb-1 {{ titleThird }}
          .text-g5 {{ valueThird }}
</template>

<script>
export default {
  name: 'TriStatCard',
  props: {
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: true
    },
    titleFirst: {
      type: String,
      required: true
    },
    valueFirst: {
      required: true,
    },
    titleSecond: {
      type: String,
      required: true
    },
    valueSecond: {
      required: true,
    },
    titleThird: {
      type: String,
      required: true
    },
    valueThird: {
      required: true,
    }
  }
}
</script>